import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { BaseField, DollarField } from '../../fields';
import { toDollarFormat } from '../../../utils';

const selector = formValueSelector('bonusRateForm');

const propTypes = exact({
  memberPath: PropTypes.string.isRequired,
  calculatedRowBonus: PropTypes.number.isRequired,
  isUserBonusEligible: PropTypes.bool.isRequired,
  fullname: PropTypes.string.isRequired,
  workedHours: PropTypes.object.isRequired,
});

const calculateRateBonus = (paramHours, paramRate) => {
  const rate = paramRate || 0;
  return (paramHours * rate);
};


const tooltip = (
  <Tooltip id="tooltip">
    <strong>User Ineligible For Bonus</strong>
  </Tooltip>
);

const MaybeOverlayTrigger = (props) => {
  const { isuserbonuseligible } = props;

  const showOverlay = (isuserbonuseligible === 'true');
  if (!showOverlay) {
    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        {props.children}
      </OverlayTrigger>
    );
  }

  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
};

const UserTicketBonusPercentageField = (props) => {
  const {
    memberPath,
    calculatedRowBonus,
    isUserBonusEligible,
    fullname,
    workedHours,
  } = props;

  return (
    <tr>
      <td>
        {fullname}
      </td>
      <td>{workedHours.to_string}</td>
      <td>
        <MaybeOverlayTrigger isuserbonuseligible={`${isUserBonusEligible}`}>
          <div>
            <DollarField
              name={`${memberPath}.bonus_rate`}
              label={null}
              componentProps={{ disabled: (!isUserBonusEligible) ? 'disabled' : '' }}
            />
          </div>
        </MaybeOverlayTrigger>
      </td>
      <td>{toDollarFormat(calculatedRowBonus)}</td>
      <td>
        <MaybeOverlayTrigger isuserbonuseligible={`${isUserBonusEligible}`}>
          <div>
            <BaseField
              name={`${memberPath}.notes`}
              label={null}
              componentProps={{ disabled: (!isUserBonusEligible) ? 'disabled' : '' }}
            />
          </div>
        </MaybeOverlayTrigger>
      </td>
    </tr>
  );
};


UserTicketBonusPercentageField.propTypes = propTypes;

/* eslint-disable react/forbid-prop-types */
MaybeOverlayTrigger.propTypes = exact({
  isuserbonuseligible: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
});
/* eslint-enable react/forbid-prop-types */

const enhance = connect((state, ownProps) => {
  const rowBonusRate = selector(state, `${ownProps.memberPath}.bonus_rate`);
  const fullname = selector(state, `${ownProps.memberPath}.user.fullname`);
  const isUserBonusEligible = selector(state, `${ownProps.memberPath}.user_bonus_eligible`);
  const billingHours = selector(state, `${ownProps.memberPath}.ticket.billing_hours`);
  const workedHours = selector(state, `${ownProps.memberPath}.worked_hours`);

  return {
    calculatedRowBonus: calculateRateBonus(billingHours, rowBonusRate),
    fullname,
    isUserBonusEligible,
    workedHours,
  };
}, {});

export default enhance(UserTicketBonusPercentageField);
